//import autoTable from 'jspdf-autotable';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { columnsTablePDF } from "components/reactreport/Table";
import { Table2 as TableReport } from "components/reactreport/Table2"

const styles = StyleSheet.create({
  page: {
    paddingTop: 81,
    paddingBottom: 80,
    paddingHorizontal: 30,
  },
  header: {
    position: 'absolute',
    top: 10,
    left: 10,
    right: 10,
    height: 70,
    fontSize: 12,
    color: 'gray',
    fontFamily:'Helvetica'
  },
  footer: {
    position: 'absolute',
    bottom: 10,
    left: 10,
    right: 10,
    height: 70,
    textAlign: 'center',
    fontSize: 12,
    color: 'gray',
  },
  title: { paddingTop: "3px" },
  logo: { width: "100%", margin: "0 auto 0 auto", objectFit: "scale-down" },
  columnTable: { fontSize: "8px", color:'gray' },
  row: { display: "flex", flexDirection: "row", alignItems: "flex-start", paddingBottom: "5px" },
  column: { fontSize: "8px", flexBasis: `20%` },
  columnTitle: { fontFamily: "Helvetica-Bold", fontSize: "8px", color:'#4c2364' },
  columnTable2:{
    fontSize: 12,
    textAlign: "center",
    fontFamily: "Helvetica",
    display: "flex",
    padding: 5,
    alignItems: "stretch",
  }
});

 export function ReportOrdenCompra() {

  const data=[
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'MIGRAFLASH CAP-BLANX1/100MGX10 1892', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe: '40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
    {descripcion: 'TENA SLIP CLASICO GDE X 3  8582', cantidad:'50', precio_u:'50.00',  desc_porcentaje:'20.00', iva:'15.00', descuento: '10.00', importe:'40.00'},
  ]

  const total = data.reduce((total: any, fila: any) => total + Number(fila.importe), 0).toFixed(2); 
    const columnsTable: columnsTablePDF[] = [
      {
        title: "Descripción",
        dataIndex: "descripcion",
        styleColumnHeader: { ...styles.columnTitle, flexBasis: "150%", textAlign: "center" },
        styleColumn: { ...styles.columnTable, flexBasis: "150%", textAlign: "left", backgroundColor: "white",  },
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        styleColumnHeader: { ...styles.columnTitle, flexBasis: "50%" },
        styleColumn: { ...styles.columnTable, flexBasis: "50%", textAlign: "right", backgroundColor: "white" },
      },
      {
        title: "P. Unitario",
        dataIndex: "precio_u",
        styleColumnHeader: { ...styles.columnTitle, flexBasis: "50%" },
        styleColumn: { ...styles.columnTable, flexBasis: "50%", textAlign: "right", backgroundColor: "white" },
      },      {
        title: "Disc %",
        dataIndex: "desc_porcentaje",
        styleColumnHeader: { ...styles.columnTitle, flexBasis: "50%" },
        styleColumn: { ...styles.columnTable, flexBasis: "50%", textAlign: "right", backgroundColor: "white" },
      },
      {
        title: "Iva",
        dataIndex: "iva",
        styleColumnHeader: { ...styles.columnTitle, flexBasis: "50%" },
        styleColumn: { ...styles.columnTable, flexBasis: "50%", textAlign: "right", backgroundColor: "white" },
      },      {
        title: "Disc $",
        dataIndex: "descuento",
        styleColumnHeader: { ...styles.columnTitle, flexBasis: "50%" },
        styleColumn: { ...styles.columnTable, flexBasis: "50%", textAlign: "right", backgroundColor: "white" },
      },      {
        title: "Importe",
        dataIndex: "importe",
        styleColumnHeader: { ...styles.columnTitle, flexBasis: "50%" },
        styleColumn: { ...styles.columnTable, flexBasis: "50%", textAlign: "right", backgroundColor: "white" },
      },
    ]
  
    return (
      <>
          <Document title="Orden de Compra">
            <Page size="A4" style={ styles.page }>
        {/* Encabezado */}
        <View fixed style={styles.header}>
        <View style={styles.row}>
        <View style={{width: '20%',paddingRight: 10, paddingLeft: 20, paddingTop:15}}>
        <Image style={styles.logo} src="/imagen/logoMIA.png" />
        </View>
        <View style={{width: '80%',paddingLeft: 10, paddingTop:5}}>
          <Text style={{fontSize: '9px'}}>FARMAMIA CIA. LTDA.</Text>
          <Text style={{fontSize: '8px', paddingTop:'4px'}}>LA ESPERANZA REFERENCIA: VIA PANAMERICANA, FRENTE A LA GASOLINERA</Text>
          <Text style={{fontSize: '8px', paddingTop:'4px'}}>TERPEL</Text>
          <Text style={{fontSize: '8px', paddingTop:'4px'}}>MACHALA</Text>
          <Text style={{fontSize: '8px', paddingTop:'4px'}}>ECUADOR</Text>
        </View>
      </View>
      <View style={{height: 0.5, backgroundColor: '#e3e1e1', marginTop: '5px', marginLeft:'20px', marginRight:'10px'}} />
      </View>

      {/* Pie de página */}
      <View fixed style={styles.footer}>
      <View style={{height: 0.5, backgroundColor: 'black', marginTop: '10px', marginLeft:'20px', marginRight:'10px'}} />
      <View style={{width: '100%',paddingLeft: 10, paddingTop:5, paddingBottom:5}}>
        <Text style={{fontSize: '8px'}}> +593 7-370-2200 send@farmaciasmia.com https://www.farmaciasmia.com 0791740150001</Text>
      </View>
      <View style={{height: 0.5, backgroundColor: 'black', marginTop: '5px', marginLeft:'20px', marginRight:'10px'}} />
      <View style={{fontSize: '8px', marginTop:'5px'}}>
        <Text
          render={({ pageNumber, totalPages }) =>
            `Página: ${pageNumber} de ${totalPages}`
          }
          fixed
        />
      </View>
      </View>
            {/* Contenido principal */}
       <View>
        <View style={{...styles.row, paddingTop:'5px'}}>
        <View style={{width: '60%', border:'1px solid', paddingRight:'50px'}}>
        <Text style={{...styles.columnTitle, textAlign:'left', fontSize:'7px', paddingTop:'5px'}}>Dirección de envío: </Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>BODEGA MACHALA FF024 </Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>LA ESPERANZA REFERENCIA: VIA PANAMERICANA, FRENTE A LA GASOLINERA TERPEL</Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>MACHALA</Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>Ecuador</Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>0984892050: </Text>
        </View>
        <View style={{width: '40%', }}>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'5px'}}>FARMALIGHT S.A.</Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>AV. JUAN TANCA MARENGO CIUDADELA SANTA ADRIANA MZ B SOLAR 4</Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>Ecuador</Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>999999999</Text>
        <Text style={{...styles.columnTable, textAlign:'left', fontSize:'7px', paddingTop:'2px'}}>RUC: 0992412755001</Text>
        </View>
        </View>
        <View style={{...styles.row, marginTop:'5px'}}>
          <Text style={{color:'#b42502', fontSize:'15px'}}>Orden de Compra #</Text>
        </View>
        <View style={{...styles.row, marginTop:'5px',paddingBottom:'0px', marginBottom:'0px'}} > 
        <Text  style={{...styles.columnTitle, flexBasis:'10%'}}>Comprador:</Text>
              <Text  style={{ ...styles.columnTable, flexBasis: "50%" }}>ESPINOSA TERAN MARIA ERMELINDA</Text>
              <Text  style={{ ...styles.columnTitle, flexBasis: "15%" }}>Fecha de la Orden:</Text>
              <Text  style={{ ...styles.columnTable, flexBasis: "20%" }}>01/01/2025 23:59:59</Text>
        </View>
        <View style={{...styles.row, marginBottom:'10px', paddingTop: '0px', paddingBottom:'0px' }} > 
        <Text  style={{...styles.columnTitle, flexBasis:'10%' , paddingTop: '0px', paddingBottom:'0px' }}></Text>
              <Text  style={{ ...styles.columnTable, flexBasis: "50%" , paddingTop: '0px'}}></Text>
              <Text  style={{ ...styles.columnTitle, flexBasis: "15%", paddingTop: '0px', paddingBottom:'0px'  }}>Fecha de Solicitud:</Text>
              <Text  style={{ ...styles.columnTable, flexBasis: "20%", paddingTop:'0px', paddingBottom:'0px' }}>01/01/2025 23:59:59</Text>
        </View>
        <View>
          <TableReport key={"table"} styleRow={{ width: "100%", fontSize:'10px', padding:'0px', margin:'0px'}} styleRowHeader={{fontSize:'10px', padding:'5px'}} columns={columnsTable}   dataSource={data} />
        </View>
        <View style={{height: 0.5, backgroundColor: '#e3e1e1', marginTop: '5px', marginLeft:'360px'}} /> 
        <View style={{...styles.row, marginTop:'8px', marginLeft:'360px'}} > 
        <Text  style={{...styles.columnTitle, flexBasis:'50%', marginLeft:'10px', color:'black'}}>Subtotal</Text>
              <Text  style={{ ...styles.columnTable, flexBasis: "50%", textAlign:'right', marginRight:'5px'}}>$50.00</Text>        
        </View>
        <View style={{...styles.row, marginTop:'8px',  marginLeft:'360px'}} > 
        <Text  style={{...styles.columnTable, flexBasis:'50%', marginLeft:'10px', color:'black'}}>IVA 0%</Text>
              <Text  style={{ ...styles.columnTable, flexBasis: "50%", textAlign:'right', marginRight:'5px'}}>$0.00</Text>        
        </View>
        <View style={{height: 0.5, backgroundColor: '#e3e1e1',  marginLeft:'360px'}} /> 
        <View style={{...styles.row, marginTop:'8px',  marginLeft:'360px'}} > 
          <Text  style={{...styles.columnTable, flexBasis:'50%', marginLeft:'10px', color:'black'}}>Total</Text>
          <Text  style={{ ...styles.columnTable, flexBasis: "50%", textAlign:'right', marginRight:'5px'}}>${total.toString()}</Text>        
        </View>
</View>
  </Page>
  </Document>
      </>
    )
}

